// extracted by mini-css-extract-plugin
module.exports = {"clickableCard":"ClickableCard_clickableCard__3xWaT","activeKeypress":"ClickableCard_activeKeypress__1M2hK"};